<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
<div class="container">
    <div *ngIf="appointment && appointment.length>0;  else NoAppointmentFound">
        <div class="row">
                  <div class="col-sm-6 col-md-6 col-lg-4 col-xl-4" *ngFor="let data of appointment">
              <div class="card" style="margin-top: 5%">
                  <div class="card-header">
                   <div class="row">
                     <div class="col">
                      <img class="avatar" src = "https://passport.petcart.in/images/userimgs/{{photo['id'+data.serviceprovider_id]}}">
                     </div>
                     <div class="col">
                        <h4 style="font-style: open sans"> {{doctorname['id'+data.serviceprovider_id]}}</h4> 
                      </div>
                   </div>
                  </div>
                  <div class="card-body">
                      <div class="row">
                          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                              <p  style="font-style: open-sans;" >Date : {{data.date}}</p>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                <p  style="font-style: open-sans;" >start Time : {{data.start_time | slice : 0:5}} </p>
                              </div> 
                              <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                  <p  style="font-style: open-sans;" >End Time: {{data.end_time | slice : 0:5}}</p>
                                </div> 
                                <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                    <p  style="font-style: open-sans;" >Status: {{data.status}}</p>
                                  </div> 
                             </div>
                  </div>
                 <div class="card-footer">
                   <div class="row">
                     <div class="col-6">
                        <button class="btn btn-success btn-block" routerLink='/manageprofile/appointmentdetail/{{data.id}}'>Detail</button> 
                     </div>
                     <div class="col-6" *ngIf="iscancellable(data.date,data.start_time) > this.utime && !(data.status == 'cancelled')">
                        <button class="btn btn-success3 btn-block"  (click)='  cancelAppointment(data.id,data.date,data.start_time)' >Cancel</button> 
                      </div>
                   </div>
                 </div>
                    
                  </div>
              </div>
          </div>
     </div>
     <div class="row" style="margin-top:2% ; margin-bottom:2%">
       <div class="col-6">
          <button  class="btn btn-success btn-block"  routerLink="/pulse/doctor">Take Appointment</button>  
       </div>
       <div class="col-6">
          <button  class="btn btn-success2 btn-block"  routerLink="/manageprofile">Go Back</button>  
       </div>
     </div>
</div>


    
    <ng-template #NoAppointmentFound style="font-color:red; margin-top: 50%">
        <div class="container" *ngIf="found == 0 && appointment.length == 0">
            <mat-card style="margin-top: 5%">
              <div class="row">
                <div class="col-sm-12" text-center >
                    <label style="color: #cb983f;font-size: 18px "> 
                        No Appointment Found  </label>   
                </div>
 
              </div>
               
                </mat-card>
        </div>
    </ng-template>